<button class="{{ type }} {{ cssClass }}" [ngClass]="{ disabled: disabled }" [disabled]="disabled">
  <span *ngIf="!showSpinner" class="button-content">
    <ng-content></ng-content>
    <span *ngIf="buttonText" [innerHTML]="buttonText"></span>
  </span>

  <div *ngIf="showSpinner" class="spinner-border text-light" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</button>
